import TagManager, { TagManagerArgs } from 'react-gtm-module';

import localStorage from '../pages/Root/services/storage/localstorage';
import { STORE_LAST_MONTH_USER_VISITS } from './constants';
import { GoogleTagManagerConfig } from '../moment/routes/types.ts';

export interface IEventData extends Record<string, any> {
  event: string;
}

class GTM {
  private tagManagerArgs: TagManagerArgs = {
    gtmId: 'GTM-P2VLN9R',
  };

  init() {
    TagManager.initialize(this.tagManagerArgs);
  }

  emit(eventData: IEventData) {
    window.dataLayer?.push({
      userVisits: localStorage?.get(STORE_LAST_MONTH_USER_VISITS)?.length || 1,
      ...eventData,
    });
  }

  stop() {
    window.dataLayer = [];
  }
}

const gtm = new GTM();

export default gtm;

export const setDNSMI = (value: boolean) => {
  localStorage?.set('local_mp_dnsmi', value);

  if (value) {
    gtm.stop();
  } else {
    gtm.init();
  }
};

export const getDNSMI = () => {
  return localStorage?.get('local_mp_dnsmi');
};

export const getGtmConfig = (domain: string): GoogleTagManagerConfig => {
  /****
   Domains:
   - developer: localhost
   - dev branch: fotoscapes-###.dev.mobileposse.com
   - staging: staging.fotoscapes.com, staging.get-moment.com, partner.staging.get-moment.com
   - production: mobileposse.com, fotoscapes.com, get-moment.com, partner.get-moment.com
   **/
  if (domain.endsWith('fotoscapes.com')) {
    return {
      product: 'portal',
      partner: 'digitalturbine',
      property: 'fotoscapes',
      env: domain === 'staging.fotoscapes.com' ? 'sandbox' : 'live',
    };
  } else if (domain.endsWith('get-moment.com')) {
    const stagingMatch = domain.match(/(.*\.)(staging\.)(get-moment)\.com/);
    const prodMatch = domain.match(/(.*\.)(get-moment)\.com/);
    const isStaging = domain.endsWith('staging.get-moment.com');
    const partner = isStaging
      ? stagingMatch && stagingMatch[1]?.replace('.', '')
      : prodMatch && prodMatch[1]?.replace('.', '');
    return {
      product: 'firstscreen',
      partner: partner ? partner : 'digitalturbine',
      property: 'moment',
      env: isStaging ? 'sandbox' : 'live',
    };
  } else if (domain.endsWith('mobileposse.com')) {
    return {
      product: 'portal',
      partner: 'digitalturbine',
      property: 'fotoscapes',
      env:
        domain === 'mobileposse.com' ||
        domain === 'fotoscapes.dev.mobileposse.com'
          ? 'live'
          : 'sandbox',
    };
  } else {
    // assumed to be dev environment
    return {
      product: 'portal',
      partner: 'digitalturbine',
      property: 'fotoscapes',
      env: 'sandbox',
    };
  }
};
